import { Link } from 'react-router';
import { BRAND, BUSINESS, NAVIGATION, FOOTER_LEGAL_LINKS, withFinds } from '@/config/site';
import { showsFinds, useFindsLive } from '@/client/lib/useFindsLive';
import { useI18n } from '@/client/i18n/I18nContext';
import { useConsent, GA_CONFIGURED } from '@/client/consent/ConsentContext';
import { CaroWordmark } from '@/components/Logo';
import { lp } from '@/client/i18n/locale';

export function Footer() {
  const { t } = useI18n();
  const { reopen } = useConsent();
  const label = (item: { label: string; key?: string }) =>
    item.key ? t(item.key) : item.label;
  // «Explorar»: the top-level sections; «Hallazgos» right after Shop, only
  // while a find is public (its NAVIGATION child marked requiresFinds).
  const findsShown = showsFinds(useFindsLive());
  const explore = NAVIGATION.filter((n) => !n.href.startsWith('http')).flatMap((n) => [
    n,
    ...withFinds((n.children ?? []).filter((c) => c.requiresFinds), findsShown),
  ]);
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__grid">
          <div>
            <p className="footer__brand">
              <CaroWordmark className="footer__mark" title="CARO." />
            </p>
            <p style={{ color: 'var(--color-beige)', maxWidth: '38ch', marginTop: 'var(--space-3)' }}>
              {t('footer.tagline')}
            </p>
            <p style={{ color: 'var(--color-beige)', maxWidth: '38ch', marginTop: 'var(--space-2)' }}>
              {t('footer.tagline2')}
            </p>
            <p className="footer__signature">{t('footer.signature')}</p>
            <a
              className="link-underline"
              href={BRAND.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: 'inline-block', marginTop: 'var(--space-4)' }}
            >
              @{BRAND.instagramHandle}
            </a>
          </div>

          <div>
            <h2>{t('footer.explore')}</h2>
            <ul>
              {explore.map((n) => (
                <li key={n.href}>
                  <Link to={lp(n.href)}>{label(n)}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2>{t('footer.info')}</h2>
            <ul>
              {FOOTER_LEGAL_LINKS.map((l) => (
                <li key={l.href}>
                  <Link to={lp(l.href)}>{label(l)}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="footer__legal">
          <span>© {new Date().getFullYear()} CARO. Casa de estilo</span>
          <span>{BUSINESS.legalName} · {BUSINESS.taxIdLabel} {BUSINESS.taxId}</span>
          <span>{BRAND.domain}</span>
          <span>{t('footer.prices')}</span>
          <span>
            {t('footer.madeBy')}{' '}
            <a
              className="link-underline"
              href="https://vitrina-digital.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Vitrina Digital
            </a>
          </span>
          {GA_CONFIGURED ? (
            <button
              type="button"
              className="link-underline"
              style={{ background: 'none', border: 'none', color: 'inherit', padding: 0, cursor: 'pointer' }}
              onClick={reopen}
            >
              {t('consent.configure')}
            </button>
          ) : null}
        </div>
      </div>
    </footer>
  );
}
